var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.31641C4 6.64249 4.52678 7.91426 5.46447 8.85194C6.40215 9.78962 7.67392 10.3164 9 10.3164C10.3261 10.3164 11.5979 9.78962 12.5355 8.85194C13.4732 7.91426 14 6.64249 14 5.31641C14 3.99032 13.4732 2.71855 12.5355 1.78087C11.5979 0.843191 10.3261 0.316406 9 0.316406C7.67392 0.316406 6.40215 0.843191 5.46447 1.78087C4.52678 2.71855 4 3.99032 4 5.31641ZM7.69141 13.1367L8.41797 14.3477L7.11719 19.1875L5.71094 13.4492C5.63281 13.1328 5.32812 12.9258 5.01172 13.0078C2.27734 13.6914 0.25 16.168 0.25 19.1172C0.25 19.7812 0.789063 20.3164 1.44922 20.3164H6.59766C6.59766 20.3164 6.59766 20.3164 6.60156 20.3164H6.8125H11.1875H11.4023C11.4023 20.3164 11.4023 20.3164 11.4062 20.3164H16.5508C17.2148 20.3164 17.75 19.7773 17.75 19.1172C17.75 16.168 15.7227 13.6914 12.9883 13.0078C12.6719 12.9297 12.3672 13.1367 12.2891 13.4492L10.8828 19.1875L9.58203 14.3477L10.3086 13.1367C10.5586 12.7188 10.2578 12.1914 9.77344 12.1914H9H8.23047C7.74609 12.1914 7.44531 12.7227 7.69531 13.1367H7.69141Z",
    fill: "#5063EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducator);
export default __webpack_public_path__ + "static/media/educator.ce5147da0b3edbc4005fce37534012ff.svg";
export { ForwardRef as ReactComponent };